import React from 'react';
import PropTypes from 'prop-types';

const SpinLoading = (props) => {
  return (
    <React.Fragment>
      {props.show &&
        <div className="text-center">
          <i className="fas fa-spinner fa-pulse fa-5x text-primary" />
        </div>
      }
    </React.Fragment>
  );
}

SpinLoading.propTypes = {
  show: PropTypes.bool.isRequired
}

SpinLoading.defaultProps = {
  show: false
}

export default SpinLoading;